import classes from "./Comment/CommentField.module.css";
import util from "../styles/utilities.module.css";
import ReactDOM from "react-dom";
const Modal = ({children}) => {
  return ReactDOM.createPortal(
    <div  className={`${util.modalOverlay} ${classes["modal-overlay"]}`}>
      <div style={{width:"350px", padding:"30px"}}  className={`${util.modalSurface} ${classes.infoModal}`}>
        <div>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
